import {Form, Input, Button, Checkbox, Typography, Card} from 'antd';
import {useTranslation} from "react-i18next";
import {useUser} from "../Context/UserContext";
import {useEffect, useState} from "react";
import {use} from "i18next";
import {useHistory} from "react-router-dom";
import ApiService from "../Service/ApiService";

export default function LoginForm()
{
    const {t} = useTranslation();
    const {user, setToken, isAuth, setSettings} = useUser();
    const history = useHistory();
    const [error, setError] = useState('')

    const signIn = async (form) => {
        const response = await ApiService.Auth.Login({
            ...form
        })
        if(!response.success)
        {
            setError('Username or password is incorrect!')
            return
        }
        setToken(response.data.token)
    }

    const redirectToHome = async () => {
        if(isAuth())
        {
            const res = await ApiService.User.UserSettings()
            if(res.success) {
                setSettings({
                    settings: JSON.parse(res.data.settings),
                    defaultSettings: res.data.defaultSettings,
                })
            }

            if(!res.data.dontShow) {
                localStorage.setItem('show-tutorial', 'show-tutorial')
            }

            history.push('/app')
        }
    }

    useEffect(() => {
        redirectToHome()
    }, [])

    useEffect(() => {
        redirectToHome()
    }, [user])

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
                <div style={{width: '50%', height: '50%', display: 'flex', alignItems: 'center', minHeight: 500, minWidth: 1000}}>
                    <div style={{flex: 1, backgroundColor: '#035781', height: '100%', width: '100%', display: 'flex', alignItems: 'center'}}>
                        <div style={{width: '100%', display: "flex", alignItems: 'center', flexDirection: 'column'}}>
                            <img src={'/LogoB41.png'} width={256} height={256}/>
                        </div>
                    </div>
                    <div style={{flex: 1, height: '100%', backgroundColor: '#fff', display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '10%', marginRight: '10%'}}>
                            <div style={{fontSize: '23pt'}}>
                                Login
                            </div>
                            <br/>
                            <Form
                                name="basic"
                                initialValues={{ remember: true }}
                                autoComplete="off"
                                onFinish={signIn}
                            >
                                <Form.Item
                                    name="email"
                                    rules={[{ required: true, message: t('Please input your email!') }]}
                                >
                                    <Input
                                        style={{
                                            fontSize: '13pt'
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: t('Please input your password!') }]}
                                >
                                    <Input.Password
                                        style={{
                                            fontSize: '13pt'
                                        }}
                                    />
                                </Form.Item>
                                <Typography.Text style={{color: '#ff0000', fontWeight: 'bold'}}>
                                    {t(error)}
                                </Typography.Text>

                                <div style={{width: 400}}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        size={'large'}
                                        style={{fontSize: '13pt', padding: 'none',
                                            paddingBottom: 8}}
                                    >
                                        <div style={{marginTop: -2}}>
                                            Login
                                        </div>
                                    </Button>
                                    <Button
                                        type="text"
                                        onClick={() => {
                                            history.push('/app/reset-password/send')
                                        }}
                                        size={'large'}
                                        style={{fontSize: '13pt', padding: 'none',
                                            paddingBottom: 8, marginLeft: 8}}
                                    >
                                        <div style={{marginTop: -2}}>
                                            Reset Password
                                        </div>
                                    </Button>
                                </div>
                            </Form>
                            <br/>
                            <br/>
                            <br/>
                            <div style={{width: '100%', fontSize: '13pt'}}>
                                Don't have an account yet? <a href={'/app/register'}>
                                <Button
                                    size={'large'}
                                    style={{
                                        borderColor: '#035781',
                                        color: '#035781',
                                        fontSize: '13pt',
                                        padding: 'none',
                                    }}
                                >
                                    <div style={{marginTop: -2}}>
                                        Sign up
                                    </div>
                                </Button>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
